// Define your default list
const defaultList = [
    {
        id: 'default-list',
        listname: "Default List",
        created: "2025-01-01",
        items: [
            { symbol: "AAPL", init_price: 150, current_price: 150, last_close: 150, price_change: 0, percent_change: 0, created: "2025-01-01" },
            { symbol: "GOOGL", init_price: 200, current_price: 200, last_close: 200, price_change: 0, percent_change: 0, created: "2025-01-01" },
        ],
        public: true,
        updated: "2025-01-01",
        userid: "default-user",
    }
];

// Helper to get initial publicList
function getInitialPublicList() {
    const stored = localStorage.getItem('public-list');
    if (stored) {
        try {
            const parsed = JSON.parse(stored)['data'];
            // Use defaultList if parsed is not a non-empty array
            if (Array.isArray(parsed) && parsed.length > 0) {
                return parsed;
            }
        } catch (e) {
            // ignore parse errors, fallback to defaultList
        }
    }
    return defaultList;
}

const initialState = {
    publicList: getInitialPublicList(),
    loading: false,
    error: null,
    lastFetched: null,
}

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case 'LOADING_PUBLIC_LIST_START':
            return {
                ...state,
                loading: true,
                error: null,
            };

        case 'LOADING_PUBLIC_LIST_SUCCESS':
            localStorage.setItem('public-list', JSON.stringify({'data': payload}));
            return {
                ...state,
                publicList: payload,
                lastFetched: Date.now(),
                loading: false,
                error: null,
            };

        case 'LOADING_PUBLIC_LIST_FAIL':
            return {
                ...state,
                loading: false,
                error: 'Failed to load public list',
            };

        default:
            return state;
    }
}

